import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: calc(100dvh - 50px);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;

  img {
    width: 150px;
    mix-blend-mode: luminosity;
  }
`;

export const BottomButtonContainer = styled.div`
  width: 100%;
  padding: 15px 24px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  background-color: white;
`;
